"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var string_1 = require("./string");
var boolean_1 = require("./boolean");
var number_1 = require("./number");
var symbol_1 = require("./symbol");
var weakMap_1 = require("./weakMap");
var weakSet_1 = require("./weakSet");
var regexp_1 = require("./regexp");
var object_1 = require("./object");
var function_1 = require("./function");
var date_1 = require("./date");
var array_1 = require("./array");
var find = require('array-find');
var mapping = [
    [String, string_1.default],
    [Boolean, boolean_1.default],
    [Number, number_1.default],
    [RegExp, regexp_1.default],
    [Object, object_1.default],
    [Function, function_1.default],
    [Date, date_1.default],
    [Array, array_1.default]
];
if (typeof Symbol !== 'undefined') {
    mapping.push([Symbol, symbol_1.default]);
}
if (typeof WeakMap !== 'undefined') {
    mapping.push([WeakMap, weakMap_1.default]);
}
if (typeof WeakSet !== 'undefined') {
    mapping.push([WeakSet, weakSet_1.default]);
}
/**
 * Finds mapping for given type constructor
 *
 * @private
 * @param {Function} type
 * @returns {Predicate}
 */
function getPredicateForType(type) {
    var result = find(mapping, function (entry) {
        return entry[0] === type;
    });
    if (result) {
        return result[1];
    }
}
exports.getPredicateForType = getPredicateForType;
